"use strict";

exports.__esModule = true;
exports.ConditionContent = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Common = require("../Common");
var _vimanaTypes = require("@vimana/vimana-types");
var _CycleClassifyBetweenOccurs = require("../Condition/CycleClassifyBetweenOccurs");
var _ConditionClassify = require("./ConditionClassify");
var _ConditionGroup = require("./ConditionGroup");
var _MessageClassify = require("./MessageClassify");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ConditionContent = exports.ConditionContent = function ConditionContent(props) {
  var _condition$duration, _condition$conditionO;
  var condition = props.condition,
    _updateSelf = props.updateSelf,
    classifyName = props.classifyName,
    isTypeDataItemOnly = props.isTypeDataItemOnly,
    singleCondition = props.singleCondition,
    first = props.first;
  var _useState = (0, _react.useState)(false),
    isGroup = _useState[0],
    setIsGroup = _useState[1];
  (0, _react.useEffect)(function () {
    setIsGroup(condition.conditionType === "GROUP_TYPE");
  }, []);
  // remove "from" value from duration if condition is not single condition
  if (first && !singleCondition && condition != null && (_condition$duration = condition.duration) != null && _condition$duration.from) {
    delete condition.duration.from;
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !isGroup ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, condition.conditionType === "MESSAGE_TYPE" ? /*#__PURE__*/_react["default"].createElement(_MessageClassify.MessageClassify, props) : null, condition.conditionType === "CONDITION_TYPE" ? /*#__PURE__*/_react["default"].createElement(_ConditionClassify.ConditionClassify, props) : null, condition.conditionType === "CYCLE_CLASSIFY_TYPE" && ((_condition$conditionO = condition.conditionOperation) == null ? void 0 : _condition$conditionO.value) === "BETWEEN" ? /*#__PURE__*/_react["default"].createElement(_CycleClassifyBetweenOccurs.CycleClassifyBetweenOccurs, {
    condition: condition,
    updateSelf: _updateSelf
  }) : null, condition.conditionType !== "MESSAGE_TYPE" && /*#__PURE__*/_react["default"].createElement(_Common.DurationInput, {
    value: condition.duration,
    setDuration: function setDuration(duration) {
      return _updateSelf(Object.assign({}, condition, {
        duration: duration
      }));
    },
    showOptions: singleCondition && (classifyName == null ? void 0 : classifyName.startsWith("classify")) && condition.conditionType === "DATA_ITEM_TYPE"
  })) : /*#__PURE__*/_react["default"].createElement(_ConditionGroup.ConditionGroup, {
    condition: condition,
    updateSelf: function updateSelf(self) {
      return _updateSelf(self);
    },
    classifyName: classifyName,
    isTypeDataItemOnly: isTypeDataItemOnly
  }));
};